const routing = {
  login: {
    path: 'login',
  },
  account: {
    path: 'account',
  },
  myProfile: {
    path: 'account/my-profile',
  },
  accountManagement: {
    path: 'account/account-management',
  },
  cities: {
    path: 'locations/cities',
  },
  universities: {
    path: 'locations/universities',
  },
  paymentList: {
    path: 'landlord/{landlordSlug}/payment/list',
  },
  paymentInitialSetup: {
    path: 'landlord/{landlordSlug}/payment/setup/initial-setup',
  },
  enablePayments: {
    path: 'landlord/{landlordSlug}/payment/setup/enable-payments',
  },
  fee: {
    path: 'landlord/{landlordSlug}/payment/setup/fee',
  },
  instalment: {
    path: 'landlord/{landlordSlug}/payment/setup/instalment',
  },
  freeCancelationPolicy: {
    path: 'landlord/{landlordSlug}/payment/setup/free-cancelation-policy',
  },
  paymentReceivingPayments: {
    path: 'landlord/{landlordSlug}/payment/setup/receiving-payments',
  },
  paymentDeposit: {
    path: 'landlord/{landlordSlug}/payment/setup/deposit',
  },
  paymentFee: {
    path: 'landlord/{landlordSlug}/payment/setup/fee',
  },
  paymentRentPayment: {
    path: 'landlord/{landlordSlug}/payment/setup/rent-payment',
  },
  paymentFirstInstalment: {
    path: 'landlord/{landlordSlug}/payment/setup/first-instalment',
  },
  paymentTerms: {
    path: 'landlord/{landlordSlug}/payment/setup/terms-and-conditions',
  },
  paymentEnablePayments: {
    path: 'landlord/{landlordSlug}/payment/setup/enable-payments',
  },
  paymentFinalizing: {
    path: 'landlord/{landlordSlug}/payment/setup/finalizing',
  },
  paymentCallback: {
    path: 'landlord/{landlordSlug}/payment/callback',
  },
  billing: {
    path: 'billing',
    childRoutes: {
      transfers: {
        path: 'transfers',
      },
      transferDetail: {
        path: 'transfer/{id}/detail',
      },
      receivables: {
        path: 'receivables',
      },
      receiveDetail: {
        path: 'receive/{id}/detail',
      },
      refunds: {
        path: 'refunds',
      },
      refundDetail: {
        path: 'refund/{id}/detail',
      },
    },
  },
  reconciliation: {
    path: 'reconciliation',
    childRoutes: {
      order: {
        path: '/order',
      },
      view: {
        path: '/landlord/{id}',
      },
      orderDetail: {
        path: '/order/{id}/detail',
      },
      bookingWithConsultant: {
        path: '/booking-with-consultant',
      },
    },
  },
  referral: {
    path: 'referral',
    childRoutes: {
      partner: {
        path: 'partner',
      },
      partnerDetail: {
        path: 'partner/{id}/detail',
      },
      partnerAccount: {
        path: 'partner-account',
      },
      partnerAccountDetail: {
        path: 'partner-account/{id}/detail',
      },
      commissionPlan: {
        path: 'commission-plan',
      },
      promotion: {
        path: 'promotion',
      },
      payoutPlan: {
        path: 'payout-plan',
      },
      payout: {
        path: 'payout',
      },
    },
  },
  city: {
    path: 'locations/city',
    childRoutes: {
      edit: {
        path: '{slug}/edit',
      },
    },
  },
  area: {
    path: 'locations/area',
    childRoutes: {
      edit: {
        path: '{slug}/edit',
      },
    },
  },
  university: {
    path: 'locations/university',
    childRoutes: {
      edit: {
        path: '{slug}/edit',
      },
    },
  },
  forgotPassword: {
    path: 'forgot-password/{email}',
  },
  forgotPasswordSuccess: {
    path: 'forgot-password/{email}/success',
  },
  resetPassword: {
    path: 'reset-password',
  },
  specialOffer: {
    path: 'marketing/special-offers',
    childRoutes: {
      create: {
        path: 'create',
      },
      edit: {
        path: 'edit/{id}',
      },
    },
  },
  property: {
    path: 'property',
    childRoutes: {
      edit: {
        path: '{propertySlug}/edit',
      },
      homepage: {
        path: '{propertySlug}/homepage',
      },
      commission: {
        path: '{propertySlug}/commission',
      },
      depositAndFees: {
        path: '{propertySlug}/deposit-and-fees',
      },
      create: {
        path: 'create',
      },
      record: {
        path: '{propertySlug}/record',
      },
      referenceAndContact: {
        path: '{propertySlug}/reference-and-contact',
      },
      changeLog: {
        path: '{propertySlug}/change-log',
        childRoutes: {
          listingManagement: {
            path: 'listing-management',
          },
          commissionManagement: {
            path: 'commission-management',
          },
          contractRecord: {
            path: 'contract-record',
          },
          policySetting: {
            path: 'policy-setting',
          },
          depositAndFees: {
            path: 'deposit-and-fees',
          },
        },
      },
      terms: {
        path: '{propertySlug}/terms',
      },
    },
  },
  properties: {
    path: 'properties',
    childRoutes: {
      create: {
        path: 'create',
      },
      listings: {
        path: '{propertySlug}/listings',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
      unitTypes: {
        path: '{propertySlug}/unit-types',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
      distinctions: {
        path: '{propertySlug}/distinctions',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
      classification: {
        path: '{propertySlug}/classification',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
    },
  },
  landlords: {
    path: 'landlords',
  },
  landlord: {
    path: 'landlord/{landlordSlug}',
  },
  contract: {
    path: 'contract',
  },
  bookings: {
    path: 'bookings',
  },
  reviews: {
    path: 'marketing/reviews',
  },
  comments: {
    path: 'comments/{propertySlug}',
  },
  agent: {
    path: 'agent',
  },
  newArticleDesign: {
    path: '/article-design/{type}/{index}',
  },
  editArticleDesign: {
    path: '/article-design/{type}/{index}/{id}',
  },
  booking: {
    path: 'booking',
    childRoutes: {
      detail: {
        path: '/{id}/detail',
      },
      manualDetail: {
        path: '/{id}/manual-detail',
      },
      bookingDetail: {
        path: '/{id}/{bookingJourney}/detail',
      },
    },
  },
  pmsIntegrations: {
    path: 'pms-integrations',
  },
  pmsIntegrationsDetails: {
    path: 'pms-integrations/details/{id}',
  },
  strategy: {
    path: 'strategy',
    childRoutes: {
      cityHomepage: {
        path: '/{name}',
      },
      homePage: {
        path: '/{name}/homepage',
      },
      heroBanner: {
        path: '/{name}/hero-banner',
      },
    },
  },
  students: {
    path: 'students',
    childRoutes: {
      detail: {
        path: '/{id}/detail',
      },
    },
  },
};

export default routing;
